import React from 'react'
import { Modal, Box } from '@mui/material'
import theme from '../theme'

interface Props {
  open: boolean
  onClose: () => void
  content: React.ReactNode
  header?: React.ReactNode
  footer?: React.ReactNode
  contentRef?: React.RefObject<HTMLDivElement>
}

const AppModal = ({ open, onClose, header, content, footer, contentRef }: Props) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: {
            xs: '95%', // Mobile: 95% width with small margins
            sm: '90%', // Small tablets: 90% width
            md: '70%', // Medium screens: 70% width
            lg: '60%', // Large screens: 60% width
            xl: '50%'  // Extra large screens: 50% width
          },
          maxWidth: '800px', // Maximum width to prevent overly wide modals
          maxHeight: '95vh', // Increased maximum height for better preview visibility
          bgcolor: theme.palette['base-white'],
          border: '1px solid',
          borderColor: theme.palette['sage-200'],
          padding: {
            xs: theme.space['16'], // Mobile: smaller padding
            sm: theme.space['24'], // Small tablets: medium padding
            md: theme.space['32'], // Medium screens: larger padding
            lg: theme.space['40']  // Large screens: full padding
          },
          borderRadius: theme.borders['rounded-10'],
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          overflow: 'hidden', // Prevent content from overflowing the modal
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)' // Add subtle shadow for better UX
        }}
      >
        <Box
          ref={contentRef}
          sx={{
            overflowY: 'auto', // Allow scrolling for content
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            scrollBehavior: 'smooth', // Enable smooth scrolling
            minHeight: 0 // Ensure flex child can shrink below content size
          }}
        >
          {header && header}
          {content}
          {footer && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: theme.space['24'],
                paddingTop: theme.space['16'],
                borderTop: `1px solid ${theme.palette['sage-200']}`,
                flexShrink: 0, // Prevent footer from shrinking
                width: '100%'
              }}
            >
              {footer}
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  )
}

export default AppModal
